
<div *ngIf="isLoading" class="loading-container">
  <mat-spinner diameter="50"></mat-spinner>
  <p>Loading lab reports...</p>
</div>

<table mat-table [dataSource]="dataSource" *ngIf="!isLoading">

  <ng-container matColumnDef="CreatedDateTime">
    <th mat-header-cell *matHeaderCellDef> Date Uploaded </th>
    <td mat-cell *matCellDef="let element">{{element.createdDateTime | date: 'MMMM d, y' }}  </td>
  </ng-container>
  <ng-container matColumnDef="Type">
    <th mat-header-cell *matHeaderCellDef> Document Type </th>
    <td mat-cell *matCellDef="let element"> {{element.type}}</td>
  </ng-container>
  <ng-container matColumnDef="Actions">
    <th mat-header-cell *matHeaderCellDef>Actions</th>
    <td mat-cell *matCellDef="let row" class="flex" style="padding: 10px;">
      <!--<a href="{{row.uploadFileURL}}" class="memberDashboard1" target="_blank" rel="noopener noreferrer">View</a>-->
      <a data-toggle="modal" class="memberDashboard1" data-target="#labWorkModal" (click)="openModal(row.uploadFileURL)">View</a> 
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
<div style="text-align:center;display:flex;" *ngIf="!isLoading">
  <mat-paginator #paginator
                 (page)="pageChangeEvent($event)"
                 [length]="this.totalRecords"
                 [pageSize]="pageSize"
                 [pageIndex]="pageIndex"
                 showFirstLastButton>
  </mat-paginator>
</div>

<div class="modal fade" id="labWorkModal" tabindex="-1" role="dialog" aria-labelledby="labWorkModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg " role="document">
    <div class="modal-content modal-size-style">
      <div class="modal-header">
        <h5 class="modal-title" id="labWorkModalLabel">View Document</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closePreview()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div *ngIf="isLoadingPreview" class="text-center py-5">Loading preview...</div>
        <div *ngIf="!isLoadingPreview && previewError" class="alert alert-warning">
          {{ previewError }}
          <div *ngIf="previewFallbackUrl" class="mt-2">
            <a [href]="previewFallbackUrl" target="_blank" rel="noopener noreferrer">Open file in new tab</a>
          </div>
        </div>
        <img *ngIf="!isLoadingPreview && !previewError && isImage" width="100%" [src]="modalImageUrl" alt="Document preview" />
        <iframe *ngIf="!isLoadingPreview && !previewError && !isImage && modalPdfUrl" id="frameStyle" [src]="modalPdfUrl" frameborder="0" width="100%" height="500px"></iframe>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closePreview()">Close</button>
      </div>
    </div>
  </div>
</div>
